import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import WorksiteTaskCollection from '../collections/WorksiteTaskCollection';
import WorksiteTaskGroupCollection from '../collections/WorksiteTaskGroupCollection';
import WorksiteTaskColumnCollection from '../collections/WorksiteTaskColumnCollection';
import WorksiteTask from '../models/WorksiteTask';

export default class WorksiteTaskEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'worksite',
            {
                'path': 'worksites/worksite-uuid/tasks',
                'responseKey': 'task',
                'responseKeyPlural': 'tasks',
                'modelClass': WorksiteTask,
                'collectionClass': WorksiteTaskCollection
            }
        );
    }

    setWorksite(worksite)
    {
        this.worksite = worksite;
        return this;
    }

    newCollection(models)
    {
        return new this.collectionClass(
            models,
            this.worksite
        );
    }

    getPath()
    {
        return this.path.replace('worksite-uuid', this.worksite.uuid);
    }

    async index(params = {}, path = this.getPath())
    {
        const searchParams = new URLSearchParams(params);

        let data = await this.request(
            `${path}?${searchParams.toString()}`
        );

        return {
            groups: new WorksiteTaskGroupCollection(data.groups, this.worksite),
            columns: new WorksiteTaskColumnCollection(data.columns, this.worksite),
        };
    }

}